<template>
	<div class="page-breadcrumb" v-if="items.length > 0">
		<router-link :to="{name: 'home'}">{{ translate('breadcrumb-home') }}</router-link>
		<template v-for="(item, index) in items">
			<div v-if="items.length === (index+1)">{{ item.title }}</div>
			<router-link v-else :to="'/' + item.route">{{ item.title }}</router-link>
		</template>
	</div>
</template>

<script lang="ts">
import {defineComponent, PropType} from "vue";
import {BreadcrumbInterface} from "../Interfaces/BreadcrumbInterface";

export default defineComponent({
	name: 'Breadcrumb',
	props: {
		items: {
			type: Object as PropType<BreadcrumbInterface[]>,
			required: true,
		}
	},
});
</script>
